import { useContext } from "react";
import { AbilityContext } from "../context/Can";
import { Action } from "src/casl/Action";

/**
 * The same test `<Can I={Action.Read} a="Ministry">` makes, as a boolean, for
 * the places that need to render something when it is false. Mirrors
 * `useMainMenuItems`, which branches the navigation on it.
 *
 * Reads false while the profile is still loading, so anything keyed on it
 * should also wait for the data it is about to render.
 */
export const useIsVolunteer = () => {
    const ability = useContext(AbilityContext);

    return ability.can(Action.Read, "Ministry");
};
